import { render, staticRenderFns } from "./ChangePassword2.vue?vue&type=template&id=10ae8d92&scoped=true&"
import script from "./ChangePassword2.vue?vue&type=script&lang=js&"
export * from "./ChangePassword2.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword2.vue?vue&type=style&index=0&id=10ae8d92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae8d92",
  null
  
)

export default component.exports